import isProjectFromGlobalTemplatesChannel from './is-project-from-global-templates-channel';

type GetProjectNameProps = {
  isAutoGeneratedName?: boolean | null;
  globalTemplateType?: string | null;
  projectName?: string;
  channel?: number;
};

export const getProjectName = ({ globalTemplateType, channel, projectName }: GetProjectNameProps) => {
  if (isProjectFromGlobalTemplatesChannel(channel) && globalTemplateType) {
    return globalTemplateType;
  }
  return projectName || '';
};

export const getDisplayProjectName = (props: GetProjectNameProps) => {
  if (props.isAutoGeneratedName) {
    return getProjectName(props).replace(/New Project.*/, 'New Project');
  }

  return getProjectName(props);
};

export const getStrippedProjectAutoNamePart = (props: GetProjectNameProps) => {
  if (props.isAutoGeneratedName) {
    // return everything after New Project
    return getProjectName(props).replace(/New Project/, '');
  }

  return '';
};
